export const INQUIRY_ERROR = "INQUIRY_ERROR";
export const GET_INQUIRY = "GET_INQUIRY";
